'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Loading } from './lib/Loading'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { MomentumScroll } from './lib/MomentumScroll'
import { EndlessSlider } from './lib/EndlessSlider'
import { FlexibleSlider } from './lib/flexibleSlider'
import { Kv } from './lib/Kv'
import { Modal } from './lib/Modal'

// new CookiePolicy('optout')
new Loading()
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new MomentumScroll()
new EndlessSlider()
new FlexibleSlider()
new Kv()
new Modal()
